import {ShippingType} from '@domain/material-demand'
import {ApiClient} from '@hconnect/apiclient'
import {AttachmentFile} from '@hconnect/common/types'

export const createDemandOverride = async ({
  plantCode,
  materialId,
  date,
  shippingType,
  quantity
}: {
  plantCode: string
  materialId: number
  date: string
  shippingType: ShippingType
  quantity: number
}): Promise<void> => {
  const path = `/plants/${plantCode}/material-demand/${materialId}/demand/overrides/${date}/shipping/${shippingType}`
  await ApiClient.axiosInstance.post<void>(path, {quantity})
}

export const uploadSalesForecast = async ({
  plantCode,
  file
}: {
  plantCode: string
  file: AttachmentFile
}): Promise<void> => {
  if (!file.originalFile) {
    throw new Error('File is missing')
  }
  const formData = new FormData()
  formData.append('salesForecastFile', file.originalFile, file.name)
  await ApiClient.axiosInstance.post<void>(
    `/plants/${plantCode}/material-demand/sales-forecast`,
    formData
  )
}
